import { useNavigate } from "react-router-dom";
import logo from "../../assets/logo-miot.png";

function Login() {
    const navigate = useNavigate();

    const handleClick = () => {
        navigate("/homepage/dashboard");
    };

    return (
        <div className="h-100 d-flex p-1 bg-light">
            <div className="container my-auto pt-5">
                <div className="row">
                    <div className="col-12 col-sm-8 col-md-6 m-auto">
                        <div className="card py-2">
                            <div className="card-body">
                                <div className="text-center mb-5">
                                    <p className="fs-1 fw-bold"> Gestione ricette </p>
                                    <img src={logo} alt="logo" width="300" />
                                </div>
                                <div className="w-75 mx-auto">
                                    <p className="fs-5 fw-bold">Username</p>
                                    <input type="text" className="form-control my-3 py-2" placeholder="Username" />
                                    <p className="fs-5 fw-bold">Password</p>
                                    <input type="text" className="form-control my-3 py-2" placeholder="Password" />
                                    <div className="text-center">
                                        <button className="btn btn-primary" onClick={handleClick}>
                                            LOGIN
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default Login;
